import { useMemo } from 'react';

import { BoxProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

import { CodeEditor, LeftBorderBox } from '@spotify/confidence-core-react';

import { MeasurementConfig } from '../../helpers/time-window';
import {
  MeasurementInput,
  averageSnippet,
  isAverageMeasurement,
  isRatioMeasurement,
  ratioSnippet,
  timeWindowSnippet,
} from './snippets';

const useStyles = makeStyles({
  dimmed: {
    opacity: 0.5,
  },
});

export type SimplifiedQueryProps = BoxProps & {
  entity?: string | null;
  factTable?: string | null;
  measurement?: MeasurementInput;
  metricWindow?: MeasurementConfig;
  dimMeasurement?: boolean;
};

const buildSnippet = (
  entity: string | null | undefined,
  factTable: string | null | undefined,
  measurement: MeasurementInput | undefined,
): string | undefined => {
  if (measurement && isAverageMeasurement(measurement)) {
    return averageSnippet({ entity, factTable, measurement });
  }
  if (measurement && isRatioMeasurement(measurement)) {
    return ratioSnippet({ entity, factTable, measurement });
  }
  return undefined;
};

export const SimplifiedQuery = ({
  entity,
  factTable,
  measurement,
  metricWindow,
  dimMeasurement = false,
  ...boxProps
}: SimplifiedQueryProps) => {
  const classes = useStyles();
  const main = useMemo(
    () => buildSnippet(entity, factTable, measurement),
    [entity, factTable, measurement],
  );
  const timeWindow = useMemo(
    () => timeWindowSnippet(metricWindow),
    [metricWindow],
  );

  if (!main) {
    return null;
  }

  return (
    <LeftBorderBox {...boxProps}>
      <div
        className={classNames({
          [classes.dimmed]: dimMeasurement && timeWindow,
        })}
      >
        <CodeEditor value={main} withBorder={false} readOnly minLines={1} />
      </div>
      {timeWindow && (
        <CodeEditor
          value={timeWindow}
          withBorder={false}
          readOnly
          minLines={1}
        />
      )}
    </LeftBorderBox>
  );
};
